import { registerWC } from '@utils/registerWebComponent'

type FoodiOfferDetailProps = {
  offerId: string
  // Lets the MFE fetch offers itself when its store is cold (deep link /
  // refresh) — the offerBuilders query requires the holding.
  holdingId?: string
  // Non-`on` names: reactify-wc would route an on* prop to addEventListener,
  // so the callbacks must use verb names to reach the MFE as properties.
  goBack: () => void
  // Navigate to the checkout screen (cart "Commander" button).
  checkout?: () => void
}

// Same bundle as foodi-commander (it registers both custom elements).
export const FoodiOfferDetail = registerWC<FoodiOfferDetailProps>(
  'foodi-offer-detail',
  '/mfe/commander',
)
